import React from 'react';
import { Button } from '@mui/material';
import { ChevronRight as ChevronRightIcon } from '@mui/icons-material';
import DataTable, { StatusColumn } from '../DataTable';
import { Customer } from '../../../types';
import { formatCnpj } from '../../../utils/formatters';

export interface CustomerData {
  id: string;
  company_name: string;
  cnpj?: string;
  sector?: string;
  code?: string;
  lastOrderDate?: string;
  lastOrderValue?: string;
  opportunityStatus?: string;
  [key: string]: unknown;
}

interface CustomersTableProps {
  data: CustomerData[];
  className?: string;
  onViewCustomer: (customerId: string) => void;
}

const CustomersTable: React.FC<CustomersTableProps> = ({ data, className, onViewCustomer }) => {
  const columns: StatusColumn[] = [
    {
      id: 'company_name',
      label: 'Cliente',
      minWidth: 200,
    },
    {
      id: 'cnpj',
      label: 'CNPJ',
      minWidth: 150,
      format: (value: unknown) => formatCnpj(value as string),
    },
    {
      id: 'sector',
      label: 'Setor',
      minWidth: 150,
    },
    // {
    //   id: 'opportunityStatus',
    //   label: 'Oportunidades',
    //   minWidth: 150,
    //   renderStatus: true,
    //   statusVariants: {
    //     '2 em aberto': { backgroundColor: '#d6f1ff', textColor: '#7198bc' },
    //     'Em análise': { backgroundColor: '#fffdf0', textColor: '#e6a816' },
    //     '1 fechada': { backgroundColor: '#fafff6', textColor: '#356e01' },
    //     Rejeitado: { backgroundColor: '#ffdee7', textColor: '#da4865' },
    //   },
    // },
    {
      id: 'id',
      label: '',
      minWidth: 100,
      format: (value: unknown) => (
        <Button
          color="primary"
          size="small"
          onClick={() => onViewCustomer(value as string)}
          endIcon={<ChevronRightIcon />}
          sx={{
            textTransform: 'none',
            color: '#4460ff',
            fontWeight: 'normal',
            fontSize: '0.875rem',
            padding: '2px 8px',
          }}
        >
          Ver cliente
        </Button>
      ),
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={data}
      statusField="opportunityStatus"
      containerClassName={className}
      fullWidth
    />
  );
};

export default CustomersTable;
